import { GridCellKind } from "@glideapps/glide-data-grid";
import React from "react";

// Define the custom cell renderer for the badge
const BadgeCellRenderer = (config) => {
  const { columns } = config;

  return {
    kind: GridCellKind.Custom,

    // Check if the cell matches this renderer
    isMatch: (cell) => cell.data.kind === "badge-cell",

    // Draw function to render the badge-like style directly on the canvas
    draw: (args, cell) => {
      const { ctx, rect } = args;
      const { value } = cell.data;

      // Find the column configuration for "verification" or the specific column that uses this renderer
      const verificationColumn = columns.find(
        (col) => col.id === "verification"
      );
      const badgeColors = verificationColumn?.badgeColors || {};

      // Determine badge color based on value using config badgeColors
      const badgeColor = badgeColors[value] || badgeColors.default || "#68D391"; // Use green as a fallback color

      ctx.save();
      ctx.fillStyle = badgeColor;

      // Draw a smaller colored rectangle
      const boxWidth = rect.width - 200; // Adjusted width
      const boxHeight = rect.height - 20; // Adjusted height
      const boxX = rect.x + (rect.width - boxWidth) / 2; // Center the box horizontally
      const boxY = rect.y + (rect.height - boxHeight) / 2; // Center the box vertically
      ctx.fillRect(boxX, boxY, boxWidth, boxHeight); // Draw the colored rectangle

      ctx.fillStyle = "#ffffff"; // Text color
      ctx.font = "12px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(value, rect.x + rect.width / 2, rect.y + rect.height / 2); // Draw the text value in the center

      ctx.restore();
      return true;
    },

    // Editor for editing the cell value
    provideEditor: () => {
      return (props) => {
        const { data } = props.value;

        // Handle value change correctly
        const handleChange = (event) => {
          props.onChange({
            ...props.value,
            data: {
              ...data,
              value: event.target.value,
            },
          });
        };

        return (
          <input
            type="text"
            value={data.value || ""}
            onChange={handleChange}
            style={{ width: "100%", border: "none", fontSize: "12px" }}
          />
        );
      };
    },
  };
};

export default BadgeCellRenderer;
